<template>
  <div :class="{ invalid: !isValid, valid: isValid }">
    <div v-if="toggleProp" class="toggle">
      <label :for="name">{{ label }}</label>
      <InputToggleSimplified :isRounded="true" @toggle="toggle" />
      <label>{{ toggleProp }}</label>
    </div>
    <label v-else :for="name">{{ label }}</label>
    <div v-if="!isValid" class="error" :class="{ toggle: toggleProp }">{{ errorDescription }}</div>

    <textarea
      autocomplete="off"
      v-if="isTextArea"
      :id="name"
      :name="name"
      :placeholder="placeholder"
      :disabled="isDisabled"
      :value="value"
      @input="updateValue($event.target.value)"
    ></textarea>
    <input
      v-else
      autocomplete="off"
      :id="name"
      :name="name"
      :disabled="isDisabled"
      :placeholder="toggled ? toggleProp : placeholder"
      :value="value"
      :class="{ centeredText: isCentered }"
      :type="isNumber ? 'Number' : 'Text'"
      @input="updateValue($event.target.value)"
    />
  </div>
</template>

<script>
import InputToggleSimplified from "@/components/base/InputToggleSimplified.vue";

export default {
  components: {
    InputToggleSimplified,
  },
  props: {
    label: String,
    name: String,
    value: String,
    isTextArea: Boolean,
    isDisabled: Boolean,
    placeholder: String,
    value: String,
    isCentered: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Boolean,
      default: true,
    },
    isNumber: {
      type: Boolean,
      default: false,
    },
    toggleProp: {
      type: String,
      default: null,
    },
    toggled: Boolean,
  },
  data() {
    return {
      currentValue: "",
      isValid: Boolean,
      errorDescription: this.label + " is not valid",
    };
  },
  methods: {
    updateValue(typed) {
      this.currentValue = typed;
      this.$emit("input", typed);
    },
    toggle() {
      this.$emit("toggle");
    },
  },
  watch: {
    validation: function(newVal, oldVal) {
      this.isValid = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/inputs";
input::placeholder {
  color: #cccccc;
}
.error {
  color: $error-color;
  position: absolute;
  top: 2px;
  right: 0;
  font-size: 13px;
  font-weight: 500;
  &.toggle {
    position: relative !important;
    top: 0 !important;
    float: right;
  }
}
.valid,
.invalid {
  &::after {
    position: absolute;
    top: 50%;
    right: -20px;
  }
}
.valid {
}
.invalid {
  input,
  textarea {
    border: 1px solid $error-color;
  }
}
.centeredText {
  text-align: center;
}
.toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;

  label {
    margin-bottom: 0 !important;
  }
}
</style>
